<template>
  <!-- <wallet /> -->
  <div>
    <div
      id="wallet-mobile"
      class="carry-out-details mobile-card-select d-sm-none profile-account d-block"
    >
      <div class="checkout-card px-0 pb-0">
        <div class="back-cart">
          <router-link :to="{ name: 'profile' }" class="back-loyalty">
            <svg class="rightarrow" fill="none">
              <use xlink:href="#left-arrow" />
            </svg>
          </router-link>
        </div>
        <h4>{{ _T('My Cashback') }}</h4>
      </div>
      <div class="select-card">
        <div class="media mobile-wallet">
          <div class="media-body">
            <h6>{{ _T('Balance') }}</h6>
            <h4 class="font-primary">
              {{ currency }} {{ Num.price(loyalty_balance) }}
            </h4>
          </div>
        </div>
      </div>
      <MobileTopup></MobileTopup>
    </div>
  </div>
</template>

<script>
import MobileTopup from './MobileWallet/MobileTopup'

import { mapGetters } from 'vuex'
export default {
  name: 'Wallet',
  components: {
    MobileTopup,
  },
  data() {
    return {
      showTopup: false,
    }
  },
  methods: {
    openTopup() {
      this.showTopup = true
    },
  },
  computed: {
    ...mapGetters(['_T', 'loyalty_balance']),
  },
}
</script>

<style lang="scss">
.mobile-card-select {
  height: 100vh;
  position: relative;
  .checkout-card {
    text-align: center;
    padding: $px18 $px20;
    background-color: white;
    border-bottom: $px12 solid $light-border;
    h4 {
      position: relative;
      margin-bottom: 0;
      font-weight: bold;
      text-transform: capitalize;
      .skip-this {
        font-weight: 600;
        font-size: $px14;
        line-height: $px17;
        letter-spacing: 0.02em;
        color: $light-font;
        position: absolute;
        right: $px2;
        top: $px4;
      }
    }
    .back-cart {
      position: absolute;
      top: $px18;
      left: $px20;
      z-index: 1;
      .rightarrow {
        width: $px16;
        height: $px16;
      }
    }
  }
  .select-card {
    padding: $px20;
    margin-bottom: $px12;
    + .select-card {
      margin-bottom: $px120;
      border-top: $px12 solid $light-border;
    }
    h6 {
      font-weight: 600;
      line-height: $px22;
      letter-spacing: 0.5px;
      margin-bottom: $px4;
    }
    .add-new-card {
      margin-top: 0;
      ul {
        li {
          display: block;
          label {
            span {
              text-align: left;
              padding: $px10 $px15;
              .media {
                .media-body {
                  margin-left: $px14;
                  span {
                    border: none;
                    padding: 0;
                    line-height: $px17;
                    letter-spacing: 0.04em;
                    color: $light-font;
                  }
                }
              }
            }
          }
          .link-add-card {
            padding: $px18;
            text-align: center;
            border: $px1 dashed $light-border;
            border-radius: $px4;
            a {
              font-weight: 600;
              letter-spacing: 0.04em;
            }
          }
        }
      }
    }
  }
  &.profile-account {
    height: auto;
    .checkout-card {
      text-align: left;
      border-bottom: none;
      padding: 0;
      h4 {
        padding: $px10 $px20 $px10 $px50;
        border-bottom: $px1 solid $light-border;
        font-weight: 600;
      }
      .back-cart {
        top: $px10;
        .back-loyalty,
        .back-carry {
          img {
            width: $px16;
          }
        }
      }
    }
    .select-card {
      + .select-card {
        margin-bottom: 0;
      }
    }
  }
}
.mobile-wallet {
  align-items: center;
  .media-body {
    h6 {
      line-height: $px17 !important;
      letter-spacing: 0.04em !important;
      margin-bottom: $px8 !important;
    }
    h4 {
      font-weight: bold;
      font-size: $px18;
      letter-spacing: 0.04em;
      margin-bottom: 0;
    }
  }
}
.transaction-mobile {
  > h6 {
    margin-bottom: 0 !important;
  }
  .media {
    padding: $px15 0;
    border-bottom: $px1 solid $light-border;
    align-items: center;
    .border-transaction {
      width: $px60;
      height: $px60;
      border: $px1 solid $dark-border;
      border-radius: $px20;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        width: $px32;
        path {
          fill: $primary-color;
        }
      }
    }
    .media-body {
      padding-left: $px15;
      h5 {
        font-weight: 600;
        letter-spacing: 0.04em;
        margin-bottom: $px3;
        span {
          font-weight: normal;
          font-size: $px12;
          line-height: $px15;
          float: right;
          letter-spacing: 0.5px;
          color: $light-font;
        }
      }
      h6 {
        font-weight: normal;
        font-size: $px13;
        line-height: $px15;
        margin-bottom: $px6;
      }
      > span {
        font-weight: 600;
        line-height: $px17;
        letter-spacing: 0.005em;
        color: $tertiary-color;
      }
    }
  }
}
.wallet-status {
  margin-top: $px30;
  ul {
    display: flex;
    li {
      width: 100%;
      text-align: center;
      a {
        font-weight: 600;
        line-height: $px17;
        padding: $px10 $px6;
        border-bottom: $px2 solid $transparent;
        letter-spacing: 0.04em;
        color: $light-font;
      }
      &.active {
        a {
          color: $primary-color;
          border-bottom: $px2 solid $primary-color;
        }
      }
    }
  }
}
</style>
